/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import Icon from "@mui/material/Icon";

// Zaim engineering components
import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "../../../components/MDBadge";

export default function buildProductTable(data, onEdit) {
  const Product = ({ name, code }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{code}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const columns = [
    { Header: "product", accessor: "product", width: "45%", align: "left" },
    { Header: "status", accessor: "status", align: "center" },
    { Header: "selling price", accessor: "selling_price", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = data.map((item) => {
    const stockStatus = item.totalQuantity <= item.minStockQty ? "Low stock" : "In stock";
    const statusColor = stockStatus === "Low stock" ? "error" : "success";

    return {
      product: <Product name={item.productName} code={item.productShortName} />,
      status: (
        <MDBox ml={-1}>
          <MDBadge badgeContent={stockStatus} color={statusColor} variant="gradient" size="sm" />
        </MDBox>
      ),
      selling_price: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          ₹{item.sellingPrice}
        </MDTypography>
      ),
      action: (
        <MDTypography
          component="a"
          href="#"
          variant="caption"
          color="text"
          fontWeight="medium"
          onClick={(e) => {
            e.preventDefault();
            onEdit(item.id);
          }}
        >
          Edit
        </MDTypography>
      ),
    };
  });

  return { columns, rows };
}
